import { privateInstance } from "../configs";

export const debugApi = {
  async convertProducts() {
    let url = `/recipes/api/debug/product/convert/`;
    const res = await privateInstance.get(url);
    return res;
  },
  async convertRecipes() {
    let url = `/recipes/api/debug/recipe/convert/`;
    const res = await privateInstance.get(url);
    return res;
  },
  async convertInventoryRecords() {
    let url = `/inventory/api/debug/record/convert/`;
    const res = await privateInstance.get(url);
    return res;
  },
  async resetConversion() {
    const res = await privateInstance.get(
      "/recipes/api/debug/product/resetconversion/"
    );
    return res;
  },
  async resetCorrectionValues() {
    const res = await privateInstance.get(
      "/inventory/api/debug/correctionvalue/reset/"
    );
    return res;
  }
};
